module.exports = __webpack_public_path__ + "img/v_7.3395660b.png";